import { dimensionUnitEnumFromOrdinal } from './dimension-unit-enum-from-ordinal-service';

// value will be an int if an automation rule exists, if the user is creating a new one value will undefined
export const getDimensionsUnitEnum = (value) => {
  if (!value) {
    return undefined;
  }

  const parsedValue = Number.parseFloat(value);
  if (!Number.isInteger(parsedValue)) {
    return undefined;
  }

  return dimensionUnitEnumFromOrdinal(parsedValue);
};
